import moment from "moment";
import { formatAssetLabel } from "../helper/formatAsset";

const transactionModel = {
  parseList(data, assetsMap, chainsMap) {
    return data.map((item) => {
      const assetId = item["asset-id"];
      const asset = assetsMap?.get(assetId);
      const chain = asset ? chainsMap?.get(asset["chain-id"]) : null;
      return {
        timestamp: moment(item["date-created"]).format("D MMM YYYY HH:mm:ss"),
        availableBalance: item["available-balance"] ?? "-",
        action: item.action || "-",
        comment: item.comment || "-",
        symbol: formatAssetLabel(asset, chain),
        amount: item.amount ?? "-",
        balance: item.balance ?? "-",
      };
    });
  },
};

export default transactionModel;
